export default __webpack_public_path__ + "assets/images/0263b948e48e2cbb50c2295e41e7b8f5.svg";